module.exports = __webpack_public_path__ + "static/media/consultation_03.5e2fd3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_03.png
// module id = 576
// module chunks = 0